var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5666 13.1721C60.2932 11.4422 63.0952 11.4395 64.8252 13.166V13.166C66.5538 14.8913 66.5581 17.6907 64.8347 19.4212L51.1764 33.1361C49.2308 35.0897 49.2339 38.2496 51.1833 40.1994L64.8684 53.8876C66.5951 55.6148 66.5963 58.4142 64.8711 60.1428V60.1428C63.1445 61.8727 60.3425 61.8755 58.6125 60.1489L38.6402 40.2155C36.6856 38.2648 36.6826 35.099 38.6333 33.1445L58.5666 13.1721Z",
    fill: "url(#paint0_linear_55_566)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4914 12.1384C28.218 10.4085 31.02 10.4058 32.75 12.1323V12.1323C34.4786 13.8576 34.4829 16.657 32.7595 18.3875L19.1012 32.1024C17.1556 34.056 17.1587 37.2159 19.1081 39.1657L32.7932 52.8539C34.5199 54.5811 34.5211 57.3805 32.7959 59.1091V59.1091C31.0693 60.839 28.2673 60.8418 26.5373 59.1152L6.56498 39.1819C4.61045 37.2311 4.60736 34.0653 6.55807 32.1108L26.4914 12.1384Z",
    fill: "url(#paint1_linear_55_566)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_566",
    x1: 51.5116,
    y1: 10.0497,
    x2: 51.5636,
    y2: 63.2851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C1B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3EBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55_566",
    x1: 19.4364,
    y1: 9.01606,
    x2: 19.4884,
    y2: 62.2514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C1B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3EBB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackDark);
export default __webpack_public_path__ + "static/media/back_dark.0437a5274819166d0b036f6f506bea5c.svg";
export { ForwardRef as ReactComponent };